export default __webpack_public_path__ + "static/media/TikTokLogo.ec1f3344.png";